module.exports = __webpack_public_path__ + "img/logo1.9ffd3d34.jpg";